import React from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { removeUser } from "../../store/slices/authSlice";
import { Link } from "react-router-dom";

const Navbar = ({ showHints, hintsLeft, takeHintHandler, onSignInOpen }) => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  // LOGOUT THE USER FROM THE APP

  const logoutHandler = () => {
    dispatch(removeUser());
  };

  return (
    <div className="game-title">
      {showHints ? (
        <div className="d-flex gap-2 gap-sm-3">
          <button
            className={clsx("white-btn", hintsLeft === 0 && "disabled")}
            onClick={takeHintHandler}
          >
            {/* <div className="tag">{hintsLeft}</div> */}
            <img src="/assets/vectors/bulb.svg" alt="bulb" />
          </button>
          <Link to="/leaderboard" className={clsx("white-btn")}>
            <img src="/assets/vectors/list.svg" alt="leaderboard" />
          </Link>
        </div>
      ) : (
        <Link className="white-btn" to="/">
          <img src="/assets/vectors/game.svg" alt="game" />
        </Link>
      )}

      <div className="nav d-flex align-items-center gap-2 gap-sm-4">
        {showHints && (
          <div className="labeller short">
            <div className="left">HINTS</div>
            <div className="right">{hintsLeft} Left</div>
          </div>
        )}
        <div className="">
          {!token ? (
            <>
              <button className="btn d-none d-sm-block" onClick={onSignInOpen}>
                SIGNUP/LOGIN
              </button>

              <button
                className={clsx("d-flex d-sm-none white-btn")}
                onClick={onSignInOpen}
              >
                <img
                  style={{ width: 28 }}
                  src="/assets/vectors/account.svg"
                  alt="account"
                />
              </button>
            </>
          ) : (
            <>
              <button className="btn d-none d-sm-block" onClick={logoutHandler}>
                LOGOUT
              </button>

              <button
                className={clsx("d-flex d-sm-none white-btn")}
                onClick={logoutHandler}
              >
                {/* <a href="https://iconscout.com/icons/exit" target="_blank">
                  Exit Icon
                </a>{" "}
                by{" "}
                  href="https://iconscout.com/contributors/rengised"
                  target="_blank"
                >
                  Alex Martynov
                </a> */}
                <img
                  style={{ width: 22 }}
                  src="/assets/vectors/logout.svg"
                  alt="logout"
                />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Navbar;
